import newhouse from '~/common/routers/newhouse.js'

let routers = [
  ...newhouse,
]

routers = routers.map(({ file, ...rest }) => rest)

export default routers
